import {
  BookOpen,
  Compass,
  Gauge,
  MessageSquareText,
  Search,
  Settings,
  ShieldCheck,
  Sparkles,
  Store,
  Tag,
  TrendingUp,
  Users,
  type LucideIcon,
} from 'lucide-react';
import { UserRole } from '@mirsad/shared';

export interface EntreeNav {
  libelle: string;
  vers: string;
  icone: LucideIcon;
  roles?: UserRole[];
  /** Compteur affiché en regard de l'entrée. */
  compteur?: 'avisFaibles';
}

export interface SectionNav {
  titre?: string;
  entrees: EntreeNav[];
}

/**
 * Navigation déclarative, filtrée par rôle à l'affichage.
 *
 * Masquer une entrée n'est pas sécuriser une route : l'autorisation réelle
 * reste celle de l'API. Cette liste sert la lisibilité, pas la sécurité.
 */
export const NAV: SectionNav[] = [
  {
    entrees: [{ libelle: 'Tableau de bord', vers: '/tableau-de-bord', icone: Gauge }],
  },
  {
    titre: 'Observation',
    entrees: [
      { libelle: 'Exploration', vers: '/exploration', icone: Compass },
      { libelle: 'Boutiques', vers: '/boutiques', icone: Store },
      // Le compteur donne les avis à 1 ou 2 étoiles des 7 derniers jours, dans le périmètre.
      { libelle: 'Avis', vers: '/avis', icone: MessageSquareText, compteur: 'avisFaibles' },
    ],
  },
  {
    titre: 'Analyse',
    entrees: [
      {
        libelle: 'Tendances',
        vers: '/tendances',
        icone: TrendingUp,
        roles: [UserRole.ADMIN, UserRole.ANALYSTE, UserRole.CONSEILLER],
      },
      { libelle: 'Prix', vers: '/prix', icone: Tag },
      {
        libelle: 'Rapports avancés',
        vers: '/rapports-avances',
        icone: Sparkles,
        roles: [UserRole.ADMIN, UserRole.ANALYSTE],
      },
      {
        libelle: 'Collectes',
        vers: '/collectes',
        icone: Search,
        roles: [UserRole.ADMIN, UserRole.ANALYSTE],
      },
      { libelle: 'Méthode', vers: '/methode', icone: BookOpen },
    ],
  },
  {
    titre: 'Administration',
    entrees: [
      {
        libelle: 'Comptes',
        vers: '/administration/comptes',
        icone: Users,
        roles: [UserRole.ADMIN],
      },
      {
        libelle: 'Paramètres',
        vers: '/administration/parametres',
        icone: Settings,
        roles: [UserRole.ADMIN],
      },
      {
        libelle: "Journal d'audit",
        vers: '/administration/audit',
        icone: ShieldCheck,
        roles: [UserRole.ADMIN],
      },
    ],
  },
];
